import { render, staticRenderFns } from "./SubmitModal.vue?vue&type=template&id=b71e532a&"
import script from "./SubmitModal.vue?vue&type=script&lang=js&"
export * from "./SubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports